export enum EUploadCSVEnrichmentStage {
    Upload = "upload",
    Enrichment = "enrichment",
    Preparing = "preparing",
    Downloading = "downloading",
    Error = "error",
}
